module.exports = __webpack_public_path__ + "static/media/success.b29cba03.mp3";